import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import ICircunstance from '../interfaces/ICircunstance';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<ICircunstance>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'circunstance'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Circunstance successfully created!'}  
        title={'Add circunstance'}  
        subheader={'Add circunstance'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
